import { ThemeProvider, createTheme } from "@mui/material";
import { MainRouter } from "./routing";

const theme = createTheme({
  typography: {
    fontFamily: "Nunito",
  },
});

function App() {
  return (
    <ThemeProvider theme={theme}>
      <MainRouter />
    </ThemeProvider>
  );
}

export default App;
